exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".listing-title{background:#fff;padding:25px 20px;z-index:20;border-bottom-left-radius:10px;border-bottom-right-radius:10px}.table td,.table th{border-top:none}", ""]);

// exports
